export const DATA_FILES_PATH = `data/cms`;

// Maximum time (ms) to wait for a static data file fetch before aborting.
// Prevents a hung request from leaving consumers stuck in a loading state.
export const FETCH_TIMEOUT_MS = 10000;
